import {token} from "@atlaskit/tokens";
import {resolveConfigColor} from "./configCardHelpers";

/**
 * Status nav icon color for workspaceConfig pages.
 * Prefers the nest status `color` from scaffold config; falls back to accent blue.
 */

const DEFAULT_STATUS_NAV_ICON_COLOR = token("color.text.accent.blue");

/**
 * Resolve sidebar status bar icon color from the nest status `color` field.
 */
export function getStatusNavIconColor(color: string | null | undefined): string {
    return resolveConfigColor(color, DEFAULT_STATUS_NAV_ICON_COLOR);
}
